export default "__VITE_ASSET__27951582__"